export const MAX_SELECTED_APPS = 12;
export const MORE_APPS_CONTAINER_WIDTH = '312px';
